import { ChevronLeft } from 'lucide-react';
import SettingsToggle from './SettingsToggle';

export default function SettingsRow({ icon, label, value, toggle, toggled, onToggle, onClick, danger }) {
  return (
    <button
      onClick={onClick || (toggle ? () => onToggle(!toggled) : undefined)}
      className={`w-full flex items-center gap-3 py-3 px-1 text-right border-b border-border last:border-0 hover:bg-muted/30 transition-colors rounded-sm ${danger ? 'text-destructive' : ''}`}
    >
      {icon && <span className="text-base flex-shrink-0 w-6 text-center">{icon}</span>}
      <span className={`flex-1 text-sm font-medium ${danger ? 'text-destructive' : 'text-foreground'}`}>{label}</span>
      {value && <span className="text-xs text-muted-foreground">{value}</span>}
      {toggle ? (
        <SettingsToggle enabled={toggled} onToggle={onToggle} />
      ) : (
        <ChevronLeft className="w-4 h-4 text-muted-foreground flex-shrink-0 rtl-flip" />
      )}
    </button>
  );
}